import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    ui_card_actions: {
        flexGrow: 0,
        padding: spacing(2),
    },
}));
//# sourceMappingURL=ui_card_actions.css.js.map